export interface TranslateField {
    key: string;
    values: TranslateOption[]
}

export const EmptyTranslateField: TranslateField = {
    key: '',
    values: []
}

export type TranslateOption = {
    locale: string;
    value: string;
}

export function ToTranslateField(key: string, eng: string, zh: string, cn: string): TranslateField {
    return {
        key: key,
        values: [
            { locale: 'en', value: eng },
            { locale: 'zh', value: zh },
            { locale: 'cn', value: cn },
        ]
    }
}

export function GetTranslated(field: TranslateField | undefined, locale: string) {
    if (field == undefined) {
        return ''
    }
    const found = field.values.find(x => x.locale == locale)
    if (found) {
        return found.value
    }
    return field.key
}